// Opacity for highlighted/dehighlighted lines/points/names:
export const normalOpacity = 1;
export const fadedOpacity = 0.15;
export const invisibleOpacity = 0;
